module.exports = __webpack_public_path__ + "img/chr_ts_90_21_2.9f6fffc1.png";